/**
 * Returns true if maintenance is currently active:
 * - isMaintenanceInProgress is true, OR
 * - plannedMaintenanceWillStartAt is in the past
 */
export const isMaintenanceActive = (config) => {
  if (!config) return false;
  if (config.isMaintenanceInProgress === true) return true;
  if (!config.plannedMaintenanceWillStartAt) return false;
  const startAt = new Date(config.plannedMaintenanceWillStartAt).getTime();
  return Date.now() >= startAt;
};

/**
 * Returns true if there is planned maintenance in the future
 */
export const hasPlannedMaintenance = (config) => {
  if (!config || !config.plannedMaintenanceWillStartAt) return false;
  const startAt = new Date(config.plannedMaintenanceWillStartAt).getTime();
  return Date.now() < startAt;
};

/**
 * Returns the message to display on the maintenance page:
 * - If duration is set and we're within the expected window: "Please check back in X minutes"
 * - If duration has passed and we're still in maintenance: "Please recheck in 15 minutes"
 * - If no duration: generic "We'll be back shortly" message
 */
export const getMaintenanceMessage = (config) => {
  if (!config) return "We'll be back shortly.";
  const durationMinutes = config.plannedMaintenanceDuration;
  const startAt = config.plannedMaintenanceWillStartAt
    ? new Date(config.plannedMaintenanceWillStartAt).getTime()
    : null;

  if (durationMinutes != null && durationMinutes > 0 && startAt != null) {
    const expectedEndAt = startAt + durationMinutes * 60 * 1000;
    const now = Date.now();

    if (now < expectedEndAt) {
      const remainingMinutes = Math.ceil((expectedEndAt - now) / 60000);
      return `Please check back in ${remainingMinutes} minute${
        remainingMinutes !== 1 ? "s" : ""
      }.`;
    }
    return "Please recheck in 15 minutes.";
  }

  return "We'll be back shortly.";
};
